export function formatCountdown(timeleft: number) {
    if (timeleft > 60 * 3 * 1000) {
        return `${Math.floor(timeleft / 60 / 1000)}m`
    }

    return `${Math.floor(timeleft / 1000)}s`
}
